var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multi-graph',{attrs:{"data":_vm.locoSectionParameters()}})}
var staticRenderFns = []

export { render, staticRenderFns }